module.exports = __webpack_public_path__ + "img/adhka-yx1zn.012.f39a6757.jpeg";